import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between px-16 w-full" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex justify-center py-3 gap-x-3" }

import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useModal, useToast } from 'vuestic-ui/web-components';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'DocsList',
  setup(__props) {

const store = useStore();
const list = ref<any[]>([])
const selectedItems = ref<typeof list.value>([])
async function getSavedDocsList() {
    const resData = (await axios.get(store.state.apiUrl + '/retab/doc/get-all-saved', {
        params: {
            page: currentPage.value,
            size: perPage.value,
            search: filterStr.value
        }
    })).data
    list.value = resData.docsList
    totalPages.value = resData.totalPages

}

function rowClick(item: typeof list.value[0]) {
    router.push('/doc/' + item.id)
   
}
async function removeSelected()  {
    
    modal.init({
        message: "Are you sure?",
        okText: 'Yes',
        cancelText: 'No',
        "child:okButton": {
            textColor: 'primary',
        },
        onOk: async () => {
            for (const item of selectedItems.value) {
                const result = await axios.delete(store.state.apiUrl + '/retab/doc/' + item.id);
                toast.init({ message:'"' + (item.title || item.altTitle || '' )+  '" Removed successfully.', color: 'success', position: 'bottom-right' });
            }
            selectedItems.value = [];
            await getSavedDocsList();

        }
    })
}
const currentPage = ref(1)
const perPage = ref(20);
const totalPages = ref(20);

function toggleSelectRow(vaEvent: any) {
    vaEvent.event?.preventDefault();
    
    
    const index = selectedItems.value.indexOf(vaEvent?.item)
    
    if (index > -1) selectedItems.value.splice(index, 1)
    else selectedItems.value.push(vaEvent.item)
}

const filterStr = ref("")
const modal = useModal();
const toast = useToast();
async function remove(id: number, ask = true) {
    modal.init({
        message: "Are you sure?",
        okText: 'Yes',
        cancelText: 'No',
        "child:okButton": {
            textColor: 'primary',
        },
        onOk: async () => {
            const result = await axios.delete(store.state.apiUrl + '/retab/doc/' + id);
            toast.init({ message: 'Removed successfully.', color: 'success', position: 'bottom-right' });
            await getSavedDocsList()
        }
    })
}


const router = useRouter();
onMounted(async () => await getSavedDocsList())
function enterModifyPage(id: any, event: Event) {
    if (['I', 'BUTTON'].includes((event.target as HTMLElement).tagName)) return;
    else router.push('/doc/' + id)
}
function newDoc() {
    router.push('/doc/' + 'new')
}

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_va_pagination = _resolveComponent("va-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_va_input, {
        modelValue: filterStr.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((filterStr).value = $event)),
          getSavedDocsList
        ],
        label: "filter",
        "inner-label": ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(_component_va_button, {
          color: "success",
          onClick: newDoc
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_icon, { name: "add" })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_va_data_table, {
      items: list.value,
      selectable: "",
      columns: [
            { key: 'title', label: 'Title', },
            { key: 'altTitle', label: 'Alt. Title', },
            { key: 'filename', label: 'Filename', },
            { key: 'createdAt', label: 'Created At', },
            { key: 'lastModifiedAt', label: 'Last Modified At', },
            { key: '', label: 'get Mei', },
            { key: 'edit', label: 'edit', },
            { key: 'remove', label: 'remove', },

        ],
      hoverable: "",
      clickable: true,
      striped: "",
      "onRow:click": _cache[1] || (_cache[1] = ({ item }: any) => rowClick(item)),
      "onRow:contextmenu": _cache[2] || (_cache[2] = (vaEvent) => toggleSelectRow(vaEvent)),
      modelValue: selectedItems.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedItems).value = $event))
    }, {
      "cell(title)": _withCtx(({ rowData }) => [
        _createVNode(_component_router_link, {
          class: "w-full h-full block",
          to: '/doc/' + rowData.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(rowData.title), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      "cell(edit)": _withCtx(({ rowData }) => [
        _createVNode(_component_router_link, {
          to: '/doc/' + rowData.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_icon, {
              role: "button",
              name: "edit",
              color: "info"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      "cell(createdAt)": _withCtx(({value}) => [
        _createTextVNode(_toDisplayString(new Date(value).toLocaleString()), 1)
      ]),
      "cell(lastModifiedAt)": _withCtx(({value}) => [
        _createTextVNode(_toDisplayString(new Date(value).toLocaleString()), 1)
      ]),
      "cell(remove)": _withCtx(({ rowData }) => [
        _createElementVNode("button", {
          onClick: ($event: any) => (remove(rowData.id))
        }, [
          _createVNode(_component_va_icon, {
            role: "button",
            name: "delete",
            color: "danger"
          })
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["items", "modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_va_button, {
        onClick: removeSelected,
        color: "danger",
        disabled: !selectedItems.value.length,
        icon: "delete"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Delete Selected", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_va_pagination, {
        pages: totalPages.value,
        modelValue: currentPage.value,
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((currentPage).value = $event)),
          getSavedDocsList
        ]
      }, null, 8, ["pages", "modelValue"])
    ])
  ]))
}
}

})